import { gql } from '@apollo/client';

export const GENERATE_TOKEN_AS_ADMIN = gql`
  mutation GenerateTokenAsAdmin($email: String!) {
    generateCustomerTokenAsAdmin(input: { customer_email: $email }) {
      customer_token
    }
  }
`;
